import { FunctionComponent, PropsWithChildren } from 'react';
import { AppHeader, Account, Layout } from '@cbridge-modules/layout';
import { useClientRootNavigation } from '@cbridge-packages/routing-client-admin';
import { useBranding } from '../branding/useBranding';
import { AccountLanguage } from './AccountLanguage';
import { ToolbarActions } from './ToolbarActions';

const accountSlots = { popoverBody: AccountLanguage };

export const AppLayout: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const navigation = useClientRootNavigation();
  const { logoSrc } = useBranding();

  return (
    <Layout>
      <AppHeader
        navigation={navigation}
        logo={<img src={logoSrc} alt={'logo'} />}
        slots={{
          toolbarAccount: Account,
          toolbarActions: ToolbarActions,
        }}
        slotProps={{
          toolbarAccount: { slots: accountSlots },
        }}
      />

      {children}
    </Layout>
  );
};
